import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import request from "./utils/request";

export function fetchAutoConsumptions(dataParams = {}, isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'autoConsumptions', value: true });
    
    const paging = getState().automaticConsumption.paging;
    const currentCount = getState().automaticConsumption.count;

    const params = { ...dataParams };
    if (!isGetAll) {
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
    } 

    try {
        if (!withoutCount && currentCount === 0) {
            const count = await request({ method: 'get', url: urls.autoConsumptions+'/count' });
            dispatch({ type: 'SET_AUTO_CONSUMPTION_COUNT', count });
        }
        const autoConsumptions = await request({ method: 'get', url: urls.autoConsumptions, params });
        dispatch({ type: 'SET_AUTO_CONSUMPTIONS', autoConsumptions });
        dispatch({ type: 'SET_LOADER', field: 'autoConsumptions', value: false });
    } catch(error) {
        dispatch(setError(error, 'autoConsumptions'));
        dispatch({ type: 'SET_LOADER', field: 'autoConsumptions', value: false });
    }
}
}

export function fetchAutoConsumption(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'autoConsumption', value: true });

    return request({ method: 'get', url: `${urls.autoConsumptions}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_AUTO_CONSUMPTION', autoConsumption: response });
            dispatch({ type: 'SET_LOADER', field: 'autoConsumption', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'autoConsumption'));
            dispatch({ type: 'SET_LOADER', field: 'autoConsumption', value: false });
            return null
        });
    }
}

export function deleteAutoConsumption(id) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'autoConsumptions', value: true });

        request({ method: 'delete', url: `${urls.autoConsumptions}/${id}` })
            .then((response) => {
                dispatch(fetchAutoConsumptions());
                dispatch({ type: 'SET_LOADER', field: 'autoConsumptions', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'autoConsumptions'));
                dispatch({ type: 'SET_LOADER', field: 'autoConsumptions', value: false });
            });
    }
}

export function setAddAutoConsumption(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_AUTO_CONSUMPTION', data });
        if (!data.name) {
            dispatch(resetError('addAutoConsumption'));
        }
    }
}

export function addAutoConsumption(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addAutoConsumption', value: true });

    return request({ method: 'post', url: urls.autoConsumptions, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addAutoConsumption', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addAutoConsumption'));
            dispatch({ type: 'SET_LOADER', field: 'addAutoConsumption', value: false });
            return false;
        });
    }
}

export function setAutoConsumptionEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_EDIT_AUTO_CONSUMPTION', data });
    }
}

export function updateAutoConsumption(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editAutoConsumption', value: true });
    dispatch(resetError('editAutoConsumption'));
    return request({ method: 'put', url: `${urls.autoConsumptions}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editAutoConsumption', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'addAutoConsumption'));
            dispatch({ type: 'SET_LOADER', field: 'editAutoConsumption', value: false });
            return false;
        });
    }
}

export function setAutoConsumptionsPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_AUTO_CONSUMPTIONS_PAGING', paging });
    }
}
